// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.security-manager-modal_modal-content_IKb5X {
    width: 440px;
    margin-top: 25px;
}

.security-manager-modal_body_slauC {
    background: var(--ui-white);
    padding: 1rem 1.5rem;
}

.security-manager-modal_body_slauC p {
    margin: 8px 0;
}

.security-manager-modal_buttons_b7Jyb {
    display: flex;
}

.security-manager-modal_buttons_b7Jyb :disabled {
    opacity: 0.8;
}

.security-manager-modal_deny-button_PF0_M, .security-manager-modal_allow-button_gg3XD {
    flex-grow: 1;
    font: inherit;
    color: inherit;
    padding: 0.75rem 1rem;
    border-radius: 0.25rem;
    border: 1px solid var(--ui-black-transparent);
    font-weight: 600;
    font-size: 0.85rem;
}

.security-manager-modal_deny-button_PF0_M {
    background-color: rgb(255, 92, 92);
    color: white;
    margin-right: 8px;
}

.security-manager-modal_allow-button_gg3XD {
    background-color: #24cd11;
    color: black;
}
`, "",{"version":3,"sources":["webpack://./src/components/tw-security-manager-modal/security-manager-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,sBAAsB;IACtB,6CAA6C;IAC7C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n    width: 440px;\n    margin-top: 25px;\n}\n\n.body {\n    background: var(--ui-white);\n    padding: 1rem 1.5rem;\n}\n\n.body p {\n    margin: 8px 0;\n}\n\n.buttons {\n    display: flex;\n}\n\n.buttons :disabled {\n    opacity: 0.8;\n}\n\n.deny-button, .allow-button {\n    flex-grow: 1;\n    font: inherit;\n    color: inherit;\n    padding: 0.75rem 1rem;\n    border-radius: 0.25rem;\n    border: 1px solid var(--ui-black-transparent);\n    font-weight: 600;\n    font-size: 0.85rem;\n}\n\n.deny-button {\n    background-color: rgb(255, 92, 92);\n    color: white;\n    margin-right: 8px;\n}\n\n.allow-button {\n    background-color: #24cd11;\n    color: black;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `security-manager-modal_modal-content_IKb5X`;
export { _1 as "modal-content" };
export var modalContent = `security-manager-modal_modal-content_IKb5X`;
export var body = `security-manager-modal_body_slauC`;
export var buttons = `security-manager-modal_buttons_b7Jyb`;
var _2 = `security-manager-modal_deny-button_PF0_M`;
export { _2 as "deny-button" };
export var denyButton = `security-manager-modal_deny-button_PF0_M`;
var _3 = `security-manager-modal_allow-button_gg3XD`;
export { _3 as "allow-button" };
export var allowButton = `security-manager-modal_allow-button_gg3XD`;
export default ___CSS_LOADER_EXPORT___;
